// GlobalContext.js
import React, { createContext, useContext, useState } from 'react';

function uuidv4() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}

// Create the context
const GlobalContext = createContext();

// Create the context provider
export const GlobalProvider = ({ children }) => {
  const [userData, setUserData] = useState({});
  const [displayName, setDisplayName] = useState('');
  const [isMobileDevice, setIsMobileDevice] = useState(false);
  const [chat, setChat] = useState('');
  const [chatUsers, setChatUsers] = useState([]);
  const [socket, setSocket] = useState(null);
  const [userGUID, setUserGUID] = useState(uuidv4());
  const [chatSettings, setChatSettings] = useState({});
  const [roomSettingsModal, setRoomSettingsModal] = useState(false);
  const [pendingMessages, setPendingMessages] = useState(0);
  const [showFileChooser, setShowFileChooser] = useState(false);
  const [page, setPage] = useState("");

  const updateUserData = (newValue) => setUserData(newValue);
  const updateDisplayName = (newValue) => setDisplayName(newValue);
  const updateIsMobileDevice = (newValue) => setIsMobileDevice(newValue);
  const updateChat = (newValue) => setChat(newValue);
  const updateChatUsers = (newValue) => setChatUsers(newValue);
  const updateSocket = (newValue) => setSocket(newValue);
  const updateUserGUID = (newValue) => setUserGUID(newValue);
  const updateChatSettings = (newValue) => setChatSettings(newValue);
  const updateRoomSettingsModal = (newValue) => setRoomSettingsModal(newValue);
  const updatePendingMessages = (newValue) => setPendingMessages(newValue);
  const updateShowFileChooser = (newValue) => setShowFileChooser(newValue);
  const updatePage = (newValue) => setPage(newValue);

  const contextValue = {
    userData,
    displayName,
    isMobileDevice,
    chat,
    chatUsers,
    socket,
    userGUID,
    chatSettings,
    roomSettingsModal,
    pendingMessages,
    showFileChooser,
    page,
    updateUserData,
    updateDisplayName,
    updateIsMobileDevice,
    updateChat,
    updateChatUsers,
    updateSocket,
    updateUserGUID,
    updateChatSettings,
    updateRoomSettingsModal,
    updatePendingMessages,
    updateShowFileChooser,
    updatePage
  };

  return (
    <GlobalContext.Provider value={contextValue}>
      {children}
    </GlobalContext.Provider>
  );
};

// Create a custom hook to access the context
export const useGlobalContext = () => {
  return useContext(GlobalContext);
};
